function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
/* eslint-disable max-statements */
import Modal from "../../Layout/Modal";
import React, { useState, useEffect } from 'react';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";

import { AccessLevels, PermissionType } from "../../../shared/types/permissionSchema";
import { saveEntitiesPermissions } from "../actions/actions";
import { connect } from 'react-redux';

import { UserGroupsLookupField } from "./UserGroupsLookupField";
import { MembersList } from "./MembersList";
import { loadGrantedPermissions, searchCollaborators } from "../PermissionsAPI";












const pseudoMembers = [
{
  refId: '',
  type: 'group',
  label: 'Administrators and Editors',
  level: AccessLevels.WRITE
}];


const findPublicPermission = (permissions) =>
permissions.find((p) => p.type === PermissionType.PUBLIC);

const getWarningMessage = (publishingLevel) =>
!publishingLevel ? /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Caution: the selected entities will be "), /*#__PURE__*/
_jsx("b", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "private")), ". ", /*#__PURE__*/

_jsx(Translate, {}, void 0, "Only allowed users will be able to see them")) : /*#__PURE__*/


React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Caution: the selected entities will be "), /*#__PURE__*/
_jsx("b", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "public")), ". ", /*#__PURE__*/

_jsx(Translate, {}, void 0, "Anyone will be able to see them"));



export const ShareEntityModalComponent = ({
  isOpen,
  onClose,
  sharedIds,
  saveEntitiesPermissions: savePermissions,
  storeKey
}) => {var _findPublicPermission;
  const [results, setResults] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [dirty, setDirty] = useState(false);
  const [originalPublicLevel, setOriginalPublicLevel] = useState(false);

  const searchAndLoadCollabs = async (
  searchTerm,
  currentAssignments) =>
  {
    const collaborators = await searchCollaborators(searchTerm);
    setResults(
    collaborators.filter(
    (r) => !currentAssignments.find((a) => a.refId === r.refId && a.type === r.type)));


  };

  useEffect(() => {
    loadGrantedPermissions(sharedIds).
    then((permissions) => {
      const loadedAssignments = permissions.map((p) => _objectSpread(_objectSpread({}, p), {}, { refId: p.refId }));
      setAssignments(loadedAssignments);

      const publicPermission = findPublicPermission(permissions);
      setOriginalPublicLevel((publicPermission === null || publicPermission === void 0 ? void 0 : publicPermission.level) || false);

      searchAndLoadCollabs('', loadedAssignments).catch(() => {});
    }).
    catch(() => {});

    return () => {
      setAssignments([]);
      setResults([]);
      setDirty(false);
      setOriginalPublicLevel(false);
    };
  }, []);

  const onChangeHandler = async (value) => {
    await searchAndLoadCollabs(value, assignments);
  };

  const onSelectHandler = (value) => {
    setAssignments([...assignments, _objectSpread(_objectSpread({}, value), {}, { level: value.level || AccessLevels.READ })]);
    setResults(results.filter((r) => !(value.refId === r.refId && value.type === r.type)));
    setDirty(true);
  };

  const onSaveHandler = async () => {
    await savePermissions(
    {
      ids: sharedIds,
      permissions: assignments.map((a) => ({
        refId: a.refId,
        type: a.type,
        level: a.level
      }))
    },
    storeKey);

    return onClose();
  };

  const members = pseudoMembers.concat(assignments);
  const currentPublicLevel = ((_findPublicPermission = findPublicPermission(members)) === null || _findPublicPermission === void 0 ? void 0 : _findPublicPermission.level) || false;

  return /*#__PURE__*/(
    _jsx(Modal, { isOpen: isOpen, type: "content", className: "share-modal", zIndex: 1000 }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "round-icon" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "user-plus" })), /*#__PURE__*/

    _jsx("h1", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Share with people and groups"))), /*#__PURE__*/



    _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
    _jsx(UserGroupsLookupField, {
      onChange: onChangeHandler,
      onSelect: onSelectHandler,
      options: results }), /*#__PURE__*/

    _jsx("div", { className: "member-list-wrapper" }, void 0, /*#__PURE__*/
    _jsx(MembersList, {
      members: members,
      onChange: (value) => {
        setAssignments(value.filter((m) => m.refId));
        setDirty(true);
      } })),


    originalPublicLevel !== currentPublicLevel ? /*#__PURE__*/
    _jsx("span", { className: "validation-message" }, void 0, getWarningMessage(currentPublicLevel), ".") :
    null),


    dirty ? /*#__PURE__*/
    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", className: "btn btn-default cancel-button", onClick: onClose }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "times" }), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Discard changes")), /*#__PURE__*/

    _jsx("button", { type: "button", className: "btn confirm-button btn-success", onClick: onSaveHandler }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "save" }), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save changes"))) : /*#__PURE__*/



    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", className: "btn btn-default pristine", onClick: onClose }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Close")))));





};

const mapDispatchToProps = {
  saveEntitiesPermissions
};

export const ShareEntityModal = connect(null, mapDispatchToProps)(ShareEntityModalComponent);